/**
 * Texto e tom do prazo prometido (derivados do que o backend já calculou:
 * `estado_prazo`, `dias_uteis_restantes`, `prazo_entrega_vigente_em`).
 * Nada de recontar dias aqui — o calendário de dias úteis é da unidade e
 * mora no servidor.
 */
import { ESTADO_PRAZO_TONE } from "../../../services/solicitacoes";
// Prazo é DateField (date-only): `new Date("2026-09-28")` é meia-noite UTC e
// vira dia 27 em São Paulo. `formatarDataLocal` lê a string sem fuso.
import { formatarDataLocal } from "../../../utils/dinheiro";

function plural(n, um, muitos) {
  return `${n} ${Math.abs(n) === 1 ? um : muitos}`;
}

/**
 * Devolve `{ texto, tone, titulo }` ou null quando não há o que mostrar
 * (sem prazo: ele nasce na autorização, então ABERTA fica em silêncio).
 */
export function descreverPrazo(s) {
  const estado = s?.estado_prazo;
  if (!estado || estado === "SEM_PRAZO") return null;
  const tone = ESTADO_PRAZO_TONE[estado] || "neutral";
  const data = formatarDataLocal(s.prazo_entrega_vigente_em);
  const restantes = s.dias_uteis_restantes;
  const replan = s.replanejado ? " · replanejado" : "";
  const rota = s.prazo_rota_display ? `Rota: ${s.prazo_rota_display}. ` : "";

  let texto;
  if (estado === "NO_PRAZO") {
    texto = typeof restantes === "number"
      ? `Prazo ${data} · ${plural(restantes, "d.u.", "d.u.")}`
      : `Prazo ${data}`;
  } else if (estado === "VENCE_HOJE") {
    texto = "Vence hoje";
  } else if (estado === "VENCIDO") {
    texto = typeof restantes === "number" && restantes < 0
      ? `Vencido há ${plural(-restantes, "d.u.", "d.u.")}`
      : `Vencido em ${data}`;
  } else if (estado === "CONCLUIDO_NO_PRAZO") {
    texto = "Entregue no prazo";
  } else if (estado === "CONCLUIDO_COM_ATRASO") {
    texto = "Entregue com atraso";
  } else {
    texto = s.estado_prazo_display || estado;
  }
  return {
    texto,
    tone,
    titulo: `${rota}Prazo vigente: ${data}${replan}. Dias úteis do calendário da unidade.`,
  };
}
